<template>
  <div class="form form--sidepanel">
    <h4 v-t="'user_permissions.view_coder_home'"></h4>

    <div class="form-group form-group--inline">
      <input-checkbox
        id="rating"
        :value="checked.includes('rating')"
        :onChange="(value) => onInputChange('rating', value)"
      />
      <label for="rating" v-t="'user_permissions.view_coder_home_options.rating'"></label>
    </div>

    <div class="form-group form-group--inline">
      <input-checkbox
        id="location"
        :value="checked.includes('location')"
        :onChange="(value) => onInputChange('location', value)"
      />
      <label for="location" v-t="'user_permissions.view_coder_home_options.location'"></label>
    </div>

    <div class="form-group form-group--inline">
      <input-checkbox
        id="payment_rate"
        :value="checked.includes('payment_rate')"
        :onChange="(value) => onInputChange('payment_rate', value)"
      />
      <label for="payment_rate" v-t="'user_permissions.view_coder_home_options.payment_rate'"></label>
    </div>

    <div class="form-group form-group--inline">
      <input-checkbox
        id="qc_score"
        :value="checked.includes('qc_score')"
        :onChange="(value) => onInputChange('qc_score', value)"
      />
      <label for="qc_score" v-t="'user_permissions.view_coder_home_options.qc_score'"></label>
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import InputCheckbox from '../form-components/input-checkbox';

export default {
  props: {
    row: Object,
    onChange: Function
  },

  computed: {
    checked() {
      return this.row.view_coder_home || [];
    }
  },

  methods: {
    onInputChange(key, value) {
      let row = _.cloneDeep(this.row)
      if (value == true) {
        row.view_coder_home.push(key);
      }
      else {
        row.view_coder_home = row.view_coder_home.filter(k => k != key);
      }

      this.onChange(this.row.user_id, 'view_coder_home', row.view_coder_home);
    }
  },

  components: {
    InputCheckbox
  }
}
</script>

<style lang="scss" scoped>
  h4 {
    margin-bottom: 20px;
  }
</style>